import Row from "react-bootstrap/Row"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import Form from 'react-bootstrap/Form'
import "../styles/Login.css"
import { useState } from "react"
import loginService from "../services/loginService"
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"

const Login = ({ currentUser, setCurrentUser }) => {
    const [password, setPassword] = useState(null)
    const [username, setUsername] = useState(null)
    const [error, setError] = useState(null)
    const navigate = useNavigate()
    const { t } = useTranslation()

    const handleLoginSubmit = (e) => {
        e.preventDefault()
        setError(null)
        if (!password || !username) {
            return
        }
        // Regular expression to allow only letters a-z, including äöå (case insensitive) and numbers
        // in username
        const usernameValidChars = /^[a-zA-Z0-9äöåÄÖÅ\s]+$/
        if (!usernameValidChars.test(username)) {
            setError(t("login_wrong_credentials"))
            return
        }

        loginService.postLogin(username, password)
            .then((res) => {
                if (res.status === 400) {
                    setError(t("login_wrong_credentials"))
                } else if (res.status === 200) {
                    console.log("res.data.accessToken", res.data)
                    setCurrentUser(res.data.user)
                    alert(t("login_successful"))
                    navigate("/")
                } else {
                    setError(t("login_authentication_failed"))
                }

            }).catch(err => console.error(err))
    }


    return (
        <Row>
            {
                (sessionStorage.getItem("breikkiToken") || currentUser) ?
                    <p>{t("login_already_logged_in_message")}</p>
                    :

                    <Container style={{ maxWidth: "400px" }} className="loginContainer">
                        <Form onSubmit={e => handleLoginSubmit(e)}>
                            <Form.Group className="mb-3" controlId="formUsername">
                                <Form.Label>{t("username")}</Form.Label>
                                <Form.Control type="text" placeholder={t("enter_username_placeholder")} onChange={(e) => setUsername(e.target.value)} required />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formPassword">
                                <Form.Label>{t("password")}</Form.Label>
                                <Form.Control type="password" placeholder={t("enter_password_placeholder")} onChange={(e) => setPassword(e.target.value)} required />
                            </Form.Group>
                            {
                                error ?
                                    <Alert variant="danger" dismissible>
                                        {error}
                                    </Alert>
                                    :
                                    <></>
                            }
                            <Button variant="success" type="submit">
                                {t("login_title")}
                            </Button>
                        </Form>
                        {/* <p style={{marginTop: "20px"}}>{t("not_registered_question")} <a href="/register">{t("click_here_to_register")}</a></p> */}
                    </Container>
            }
        </Row>
    )
}

export default Login